var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NeoNftCard,{attrs:{"nft":_vm.nft,"prefix":_setup.urlPrefix,"show-price":_setup.showPrice,"variant":_vm.variant,"placeholder":_setup.placeholder,"link":"nuxt-link","bind-key":"to"}})
}
var staticRenderFns = []

export { render, staticRenderFns }